import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import * as types from 'modules/whitelist/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const MODAL_CLOSE_ACTIONS = [
  LOCATION_CHANGE,
  types.CLOSE_MODAL,
  types.CREATE_WHITELIST_SUCCESS,
  types.UPDATE_WHITELIST_SUCCESS,
  types.DELETE_WHITELIST_SUCCESS,
];

export default combineReducers({
  open: createReducer(
    false,
    {
      [types.OPEN_MODAL]: () => true,
    },
    [
      {
        matcher: ({ type }) => MODAL_CLOSE_ACTIONS.includes(type),
        reducer: () => false,
      },
    ],
  ),
  entityId: createReducer(
    null,
    {
      [types.OPEN_MODAL]: (state, { payload }) => payload || null,
    },
    [
      {
        matcher: ({ type }) => MODAL_CLOSE_ACTIONS.includes(type),
        reducer: () => null,
      },
    ],
  ),
  creating: loading(types.CREATE_WHITELIST),
  updating: loading(types.UPDATE_WHITELIST),
});
